import BaseNavigationTabs from 'components/Navigation/BaseNavigationTabs';
import BaseNavigationTabsButton from 'components/Navigation/BaseNavigationTabs/BaseNavigationTabsButton';
import {NavigationTabsPropsHelper} from 'components/Navigation/BaseNavigationTabs/types';
import {FC} from 'react';
import {c} from 'ttag';

type NavigationTabsPortalProps = NavigationTabsPropsHelper<{
    flags: {
        portalAllowClientinboxUsersToEditUsers?: boolean;
    };
    mid: string;
    permissions: {
        hasAccessToClientInbox: boolean;
        hasAccessToContactInfo: boolean;
        hasAccessToPersonalInbox: boolean;
        hasEditAccessToClientInboxUsers: boolean;
    };
}>;

const NavigationTabsPortal: FC<NavigationTabsPortalProps> = ({
    className,
    flags,
    mid,
    permissions,
    selection,
}) => {
    const tabs = [
        {
            href: `/portal/${mid}/personal-inbox`,
            isEnabled: permissions.hasAccessToPersonalInbox,
            label: c('component').t`Personal Inbox`,
            name: 'personal-inbox',
        },
        {
            href: `/portal/${mid}/client-inbox`,
            isEnabled: permissions.hasAccessToClientInbox,
            label: c('component').t`Client Inbox`,
            name: 'client-inbox',
        },
        {
            href: `/portal/${mid}/client-inbox/users/`,
            isEnabled: flags.portalAllowClientinboxUsersToEditUsers,
            label: c('component').t`Settings`,
            name: 'client-inbox-users',
        },
        {
            href: `/portal/${mid}/contact-information`,
            isEnabled: permissions.hasAccessToContactInfo,
            label: c('component').t`Contact Information`,
            name: 'contact-info',
        },
    ]
        .filter((tab) => tab.isEnabled)
        .map((tab) => (
            <BaseNavigationTabsButton
                href={tab.href}
                key={tab.name}
                label={tab.label}
                name={tab.name}
            />
        ));

    if (tabs.length <= 1) {
        return;
    }

    return (
        <BaseNavigationTabs className={className} selection={selection}>
            {tabs}
        </BaseNavigationTabs>
    );
};

export default NavigationTabsPortal;
